var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPayments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 38,
    viewBox: "0 0 42 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41 18V7.22794C41 5.64599 41 4.85501 40.6118 4.03933C40.3903 3.57411 39.8861 2.94128 39.482 2.62157C38.7736 2.06103 38.1824 1.92562 37 1.65479C35.1606 1.2335 33.1318 1 31 1C27.1659 1 23.6651 1.75527 21 3C18.3349 4.24473 14.8341 5 11 5C8.86816 5 6.83937 4.7665 5 4.34521C3.08006 3.90546 1 5.25829 1 7.22794V28.7721C1 30.354 1 31.145 1.38823 31.9607C1.60966 32.4259 2.11393 33.0587 2.51797 33.3784C3.22639 33.939 3.81759 34.0744 5 34.3452C6.83937 34.7665 8.86816 35 11 35C13.9377 35 16.6797 34.5566 19 33.7894",
    stroke: "#5784F7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 33C25 33 27 33 29 37C29 37 35.3529 27 41 25",
    stroke: "#5784F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26 18C26 20.7614 23.7614 23 21 23C18.2386 23 16 20.7614 16 18C16 15.2386 18.2386 13 21 13C23.7614 13 26 15.2386 26 18Z",
    stroke: "#5784F7",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 20L8 20.018",
    stroke: "#5784F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34 15.9844L34 16.0023",
    stroke: "#5784F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPayments);
export default __webpack_public_path__ + "static/media/IconPayments.04ae60755922c32db08ef1336faf0380.svg";
export { ForwardRef as ReactComponent };